import { z } from 'zod';

export const PortfolioExposureSchema = z.object({
  dimension: z.string(),
  buckets: z.array(z.object({
    label: z.string(),
    weightPct: z.number(),
    glossaryTermId: z.string().optional(),
  })),
});

export const PortfolioResponseSchema = z.object({
  asOf: z.string(),
  liquidityFloor: z.object({
    requiredMonths: z.number(),
    currentMonths: z.number(),
    status: z.enum(['healthy', 'warning', 'critical']),
    glossaryTermId: z.string(),
  }),
  survivalBuffer: z.object({
    status: z.enum(['healthy', 'warning', 'critical']),
    rationale: z.string(),
  }),
  positions: z.array(z.object({
    positionId: z.string(),
    securityId: z.string(),
    symbol: z.string(),
    role: z.string(),
    thesisId: z.string().optional(),
    weightPct: z.number(),
  })),
  exposures: z.array(PortfolioExposureSchema),
  recommendedAction: z.string().optional(),
});

export type PortfolioResponse = z.infer<typeof PortfolioResponseSchema>;
